


















































































import { Component, Vue } from "vue-property-decorator";
import DinamicallyForm from "@/components/DinamicallyForm/DinamicallyForm.vue";
import { FormBuilderConfig } from "@/views/FormBuilder/types/FormBuilderTypes";

interface FormWithMeta extends FormBuilderConfig {
  id: string;
  createdAt: string;
  updatedAt: string;
}

@Component({
  components: {
    DinamicallyForm,
  },
})
export default class ClientesView extends Vue {
  // Headers para la tabla
  public headers = [
    { text: "ID", value: "id" },
    { text: "Nombre", value: "nombre" },
    { text: "Email", value: "email" },
    { text: "Teléfono", value: "telefono" },
    { text: "Acciones", value: "actions", sortable: false, align: "end" },
  ];

  // Datos
  public clientes: any[] = [];
  public loading: boolean = false;
  public showForm: boolean = false;
  public modoEdicion: boolean = false;
  public registroActual: any | null = null;
  public formConfig: FormBuilderConfig | null = null;

  public async created() {
    // 1. Cargar la configuración del formulario desde localStorage
    await this.cargarFormConfig();

    // 2. Cargar los registros de clientes
    await this.cargarClientes();
  }

  /**
   *  PASO 1: Cargar la configuración del formulario que creaste con el Form Builder
   */
  private async cargarFormConfig() {
    try {
      // Obtener todos los formularios guardados
      const savedForms = localStorage.getItem("formBuilder_forms");

      if (savedForms) {
        const forms = JSON.parse(savedForms);

        // Buscar el formulario de "Clientes" por nombre
        // (También podrías guardarlo por ID en una tabla de configuración)
        const clientesForm = forms.find((f: any) => f.formName === "Clientes");

        if (clientesForm) {
          this.formConfig = clientesForm;
          console.log("✅ Formulario de Clientes cargado:", this.formConfig);
        } else {
          console.warn("⚠️ No se encontró el formulario de Clientes");
        }
      }
    } catch (error) {
      console.error("Error cargando configuración del formulario:", error);
    }
  }

  /**
   * PASO 2: Cargar los registros desde el backend
   */
  private async cargarClientes() {
    this.loading = true;
    try {
      // TODO: Reemplazar con llamada real a la API
      // const response = await this.$http.get('/api/clientes');
      // this.clientes = response.data;

      // Por ahora, datos de ejemplo
      this.clientes = [
        {
          id: 1,
          nombre: "Juan Pérez",
          email: "juan@example.com",
          telefono: "612345678",
        },
        {
          id: 2,
          nombre: "María García",
          email: "maria@example.com",
          telefono: "623456789",
        },
      ];
    } catch (error) {
      console.error("Error cargando clientes:", error);
    } finally {
      this.loading = false;
    }
  }

  /**
   * PASO 3: Abrir formulario para NUEVO registro
   */
  public nuevoCliente() {
    this.modoEdicion = false;
    this.registroActual = null; // Sin datos, formulario vacío
    this.showForm = true;
  }

  /**
   * PASO 4: Abrir formulario para EDITAR registro existente
   */
  public editarCliente(cliente: any) {
    this.modoEdicion = true;
    this.registroActual = { ...cliente }; // Pasar datos del registro
    this.showForm = true;
  }

  /**
   * PASO 5: Guardar el registro (crear o actualizar)
   */
  public async guardarRegistro(datos: any) {
    console.log("💾 Guardando:", datos);

    try {
      if (this.modoEdicion) {
        // ACTUALIZAR registro existente
        // TODO: Reemplazar con llamada real a la API
        // await this.$http.put(`/api/clientes/${datos.id}`, datos);

        const index = this.clientes.findIndex((c) => c.id === datos.id);
        if (index !== -1) {
          this.clientes.splice(index, 1, datos);
        }

        console.log("✅ Cliente actualizado correctamente");
        alert("Cliente actualizado correctamente");
      } else {
        // CREAR nuevo registro
        // TODO: Reemplazar con llamada real a la API
        // const response = await this.$http.post('/api/clientes', datos);
        // this.clientes.push(response.data);

        datos.id = Date.now(); // ID temporal
        this.clientes.push(datos);

        console.log("✅ Cliente creado correctamente");
        alert("Cliente creado correctamente");
      }

      this.cerrarFormulario();
      await this.cargarClientes(); // Recargar lista
    } catch (error) {
      console.error("Error guardando:", error);
      alert("Error al guardar el cliente");
    }
  }

  /**
   * PASO 6: Cerrar el formulario y volver a la lista
   */
  public cerrarFormulario() {
    this.showForm = false;
    this.registroActual = null;
  }

  /**
   * Eliminar registro
   */
  public async eliminarCliente(cliente: any) {
    if (confirm(`¿Eliminar a ${cliente.nombre}?`)) {
      try {
        // TODO: Llamada a la API
        // await this.$http.delete(`/api/clientes/${cliente.id}`);

        const index = this.clientes.findIndex((c) => c.id === cliente.id);
        if (index !== -1) {
          this.clientes.splice(index, 1);
        }

        console.log("✅ Cliente eliminado");
        alert("Cliente eliminado");
      } catch (error) {
        console.error("Error eliminando:", error);
      }
    }
  }
}
